// extracted by mini-css-extract-plugin
export var modal = "WorkModal-module--modal--155bd";
export var slide = "WorkModal-module--slide--92f54";
export var slider = "WorkModal-module--slider--144f7";
export var stages = "WorkModal-module--stages--c87b8";
export var tabs = "WorkModal-module--tabs--19bfd";